import { IsArray, IsNumber } from 'class-validator';

export class GetRebateByCostCentersAndBusinessEntityIdsDto {
  @IsNumber()
  merchantGroupId: number;

  @IsArray()
  @IsNumber({}, { each: true })
  costCentreIds?: number[];

  @IsArray()
  @IsNumber({}, { each: true })
  businessEntityIds?: number[];

}